import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePrevious from 'common/usePrevious';
import { creatingDeliveriesResultSelector } from 'selectors/new-booking-selectors';
import NewBookingDuck from 'ducks/new-booking-duck';

const useCreatingDeliveriesResult = createDeliveriesCallback => {
  const dispatch = useDispatch();
  const creatingDeliveriesResult = useSelector(
    creatingDeliveriesResultSelector,
  );
  const prevCreatingDeliveriesResult = usePrevious(creatingDeliveriesResult);
  useEffect(
    () => {
      if (
        creatingDeliveriesResult &&
        creatingDeliveriesResult !== prevCreatingDeliveriesResult
      ) {
        createDeliveriesCallback(creatingDeliveriesResult);
        dispatch(NewBookingDuck.creators.resetCreatingDeliveriesResult());
      }
    },
    [
      dispatch,
      creatingDeliveriesResult,
      prevCreatingDeliveriesResult,
      createDeliveriesCallback,
    ],
  );
};

export default useCreatingDeliveriesResult;
